/**
 * Scan the document for all elements containing the data-parallax directive,
 * and initialize them as parallax elements.
 */
export function parallax() {
    const parallaxables = [];

    for (let element of document.querySelectorAll('[data-parallax]')) {
        parallaxables.push(new Parallaxable(element))
    }

    window.addEventListener('scroll', function() {
        for (let parallaxable of parallaxables) {
            parallaxable.update()
        }
    });
}

class Parallaxable {
    /**
     * Constructor
     *
     * @param {HTMLElement} element 
     */
    constructor(element) {
        this.element = element
        this.x = 0
        this.y = 0
        this.z = 0
        this.mode = element.dataset.parallaxMode || 'y'
        this.includeX = this.mode === 'xy' || this.mode === 'x' 
        this.includeY = this.mode === 'xy' || this.mode === 'y'
        this.strength = element.dataset.parallaxStrength || 40
    }

    /**
     * Set a transform for the element based on it's z position and parallax strength.
    */
    update() {
        this.z = this.element.dataset.parallax || 0

        if (this.z === 0 || (this.includeX || this.includeY) === false) {
            return this.clearPos()
        }

        this.updatePos()
    }

    /**
     * Set x and y position to zero and clear the transform
     */
    clearPos() {
        this.x = 0
        this.y = 0
        this.element.style.transform = null
    }

    /**
     * Determine the amount of visual drift that should have occured due to the z position, and
     * provide a transform that creates that visual drift.
     */
    updatePos() {
        const rect = this.element.getBoundingClientRect()
        const tx = this.includeX ? ((rect.right - this.x) / (window.innerWidth + rect.width)) * 2 - 1 : 0
        const ty = this.includeY ? ((rect.bottom - this.y) / (window.innerHeight + rect.height)) * 2 - 1 : 0

        this.x = this.z * tx * this.strength
        this.y = this.z * ty * this.strength
	    this.element.style.transform = `translate(${this.x}px, ${this.y}px)`
    }
}